// @ts-nocheck
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { Button } from "@/shared/components/ui";
export function Done({ onDash, isHR }) {
  return (
    <div className="min-h-dvh bg-white flex flex-col items-center justify-center p-6 sm:p-8 text-center safe-bottom">
      <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-6 text-3xl">✓</div>
      <h1 className="text-xl sm:text-3xl font-black text-ink-900 mb-2">Interview Completed</h1>
      <p className="text-ink-400 mb-5 max-w-md">Transcript recorded.</p>
      <Button size="lg" onClick={onDash}>{isHR ? "HR Dashboard" : "Dashboard"}</Button>
    </div>
  );
}

